<div class="lease-selector-enhanced">
  
  <!-- Enhanced Table -->
  <div class="selector-table-enhanced">
    <p-table 
      #dt
      [value]="leases" 
      dataKey="_id"
      [paginator]="true"
      [rows]="10"
      [rowsPerPageOptions]="[10, 25, 50]"
      [globalFilterFields]="['leaseNumber', 'folio', 'clientName', 'clientEmail']"
      [showCurrentPageReport]="true"
      currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} leases"
      responsiveLayout="scroll"
      styleClass="enhanced-lease-table"
    >
      <!-- Caption with Search -->
      <ng-template pTemplate="caption">
        <div class="table-header-actions">
          <span class="p-input-icon-left search-input">
            <i class="pi pi-search"></i>
            <input 
              pInputText 
              type="text" 
              (input)="dt.filterGlobal($any($event.target).value, 'contains')" 
              placeholder="Buscar por folio, cliente o email..."
            />
          </span>
        </div>
      </ng-template>
      
      <!-- Table Header -->
      <ng-template pTemplate="header">
        <tr>
          <th class="lease-column">
            <div class="th-content">
              <i class="fa-solid fa-file-contract"></i>
              <span>Folio de Lease</span>
            </div>
          </th>
          <th class="client-column">
            <div class="th-content">
              <i class="fa-solid fa-user"></i>
              <span>Cliente</span>
            </div>
          </th>
          <th class="email-column">
            <div class="th-content">
              <i class="fa-solid fa-envelope"></i>
              <span>Email</span>
            </div>
          </th>
          <th class="date-column">
            <div class="th-content">
              <i class="fa-solid fa-calendar"></i>
              <span>Próximo Vencimiento</span>
            </div>
          </th>
          <th class="amount-column">
            <div class="th-content">
              <i class="fa-solid fa-dollar-sign"></i>
              <span>Monto Pendiente</span>
            </div>
          </th>
        </tr>
      </ng-template>
      
      <!-- Table Body -->
      <ng-template pTemplate="body" let-lease let-rowIndex="rowIndex">
        <tr>
          <!-- Folio -->
          <td class="lease-cell">
            <div class="lease-info">
              <span class="lease-folio">{{ lease.leaseNumber || lease.folio || lease._id }}</span>
              <span class="lease-id" *ngIf="lease.leaseId">ID: {{ lease.leaseId.slice(-8) }}</span>
            </div>
          </td>
          
          <!-- Cliente -->
          <td class="client-cell">
            <div class="client-info">
              <div class="client-avatar">
                <i class="fa-solid fa-user"></i>
              </div>
              <span class="client-name">{{ lease.clientName || 'Cliente no disponible' }}</span>
            </div>
          </td>
          
          <!-- Email -->
          <td class="email-cell">
            <div class="email-info" *ngIf="lease.clientEmail">
              <i class="fa-solid fa-envelope email-icon"></i>
              <span class="email-text">{{ lease.clientEmail }}</span>
            </div>
            <span *ngIf="!lease.clientEmail" class="no-data">No disponible</span>
          </td>
          
          <!-- Vencimiento -->
          <td class="date-cell">
            <div class="date-info" *ngIf="lease.dueDate">
              <i class="fa-solid fa-calendar-day"></i>
              <span class="date-text">{{ lease.dueDate | date: 'dd/MM/yyyy' }}</span>
            </div>
            <span *ngIf="!lease.dueDate" class="no-data">No disponible</span>
          </td>
          
          <!-- Monto Pendiente -->
          <td class="amount-cell">
            <div class="amount-info">
              <span class="amount-value">{{ lease.pendingAmount | currency:'MXN':'symbol':'1.2-2' }}</span>
            </div>
          </td>
        </tr>
      </ng-template>
      
      <!-- Empty Message -->
      <ng-template pTemplate="emptymessage">
        <tr>
          <td [attr.colspan]="5" class="empty-state">
            <div class="empty-content">
              <i class="fa-solid fa-inbox"></i>
              <h4>No hay leases elegibles</h4>
              <p>No se encontraron leases que cumplan con los criterios de esta estrategia</p>
            </div>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
  
  <!-- Enhanced Footer -->
  <div class="selector-footer-enhanced">
    <div class="footer-actions">
      <button 
        pButton 
        type="button"
        [label]="'Cerrar'"
        icon="pi pi-times"
        class="p-button-outlined p-button-secondary action-button"
        (click)="cancel()"
      ></button>
    </div>
  </div>
</div>
